<template>
  <div class="preloader">
    <p v-if="showValue" class="text"
      id="cont"
    >
      {{ value +'%' }}
    </p>
  </div>
</template>

<script>
  const px = v => v + 'px'

  export default {
    created () {
      this.defaultOptions = {
        progress: {
          color: '#2dbd2d',
          backgroundColor: '#333333'
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    },
    mounted () {
      if (this.options !== null && this.options !== undefined) {
        this.mergeDefaultOptionsWithProp(this.options)
      }
    },
    props: {
      options: {
        type: Object,
        required: false
      },
      value: {
        type: Number,
        required: false,
        default: 0
      },
      showValue: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    name: 'preloader',
    data () {
      return {
        defaultOptions: Object,
        rectHeight: 0,
        radiusCircle: 104,
        strokeCircle: 0,
        strokeCircleOffset: 0,
        show: false
      }
    },
    methods: {
      mergeDefaultOptionsWithProp: function (options) {
        var result = this.defaultOptions
        for (var option in options) {
          if (options[option] !== null && typeof (options[option]) === 'object') {
            for (var subOption in options[option]) {
              if (options[option][subOption] !== undefined && options[option][subOption] !== null) {
                result[option][subOption] = options[option][subOption]
              }
            }
          } else {
            result[option] = options[option]
          }
        }
      },
    },
    watch: {
      options: function (val) {
        if (val !== null && val !== undefined) {
          this.mergeDefaultOptionsWithProp(val)
        }
      }
    }
  }
</script>
